import { render, staticRenderFns } from "./IconUserRemoveOutline.vue?vue&type=template&id=ca574a96"
import script from "./IconUserRemoveOutline.vue?vue&type=script&lang=js"
export * from "./IconUserRemoveOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports